import { useEffect, useState } from 'react';

import { useExperiment } from '@/utils/experiment/use-experiment';
import { wacRefreshJsm } from '@/utils/experiment/wac-refresh-experiments';

import {
	addJsmPlaygroundSignupIntentToHref,
	JSM_PLAYGROUND_SIGNUP_INTENT_CHANGE_EVENT,
} from '../utils/jsm-playground-signup-intent';

export const useJsmPlaygroundSignupHref = (href: string): string => {
	const experiment = useExperiment(wacRefreshJsm);
	const isEnabled = experiment.type === 'enrolled' && experiment.value;
	const [resolvedHref, setResolvedHref] = useState(() =>
		typeof window === 'undefined'
			? href
			: addJsmPlaygroundSignupIntentToHref(
					href,
					window.location.search,
					window.location.origin,
					isEnabled,
				),
	);

	useEffect(() => {
		const updateHref = () => {
			setResolvedHref(
				addJsmPlaygroundSignupIntentToHref(
					href,
					window.location.search,
					window.location.origin,
					isEnabled,
				),
			);
		};

		updateHref();
		window.addEventListener(JSM_PLAYGROUND_SIGNUP_INTENT_CHANGE_EVENT, updateHref);
		window.addEventListener('popstate', updateHref);

		return () => {
			window.removeEventListener(JSM_PLAYGROUND_SIGNUP_INTENT_CHANGE_EVENT, updateHref);
			window.removeEventListener('popstate', updateHref);
		};
	}, [href, isEnabled]);

	return resolvedHref;
};
